(function () {
  var AUTOPLAY_DELAY = 4200;

  function initWheel(root) {
    var track = root.querySelector('[data-shop-by-game-track]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-shop-by-game-item]'));
    var prevBtn = root.querySelector('[data-shop-by-game-prev]');
    var nextBtn = root.querySelector('[data-shop-by-game-next]');
    if (!track || !items.length) return;

    var activeIndex = 0;
    var isSyncing = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayTimer = null;

    var isCarouselMode = function () {
      return window.matchMedia('(max-width: 989px)').matches;
    };

    var render = function () {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === activeIndex);
      });
    };

    var scrollToIndex = function (index, behavior) {
      isSyncing = true;
      var item = items[index];
      var target = item.offsetLeft - (track.clientWidth / 2 - item.offsetWidth / 2);
      target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, target));
      track.scrollTo({ left: target, behavior: behavior || 'smooth' });
      window.setTimeout(function () { isSyncing = false; }, 600);
    };

    var setActive = function (index, behavior) {
      var len = items.length;
      activeIndex = ((index % len) + len) % len;
      render();
      if (isCarouselMode()) scrollToIndex(activeIndex, behavior);
    };

    var stopAutoplay = function () {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    var startAutoplay = function () {
      if (reducedMotion || !isCarouselMode() || items.length < 2) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(function () {
        setActive(activeIndex + 1);
      }, AUTOPLAY_DELAY);
    };

    var restartAutoplay = function () {
      stopAutoplay();
      startAutoplay();
    };

    var manualStep = function (direction) {
      setActive(activeIndex + direction);
      restartAutoplay();
    };

    var findClosestIndex = function () {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closestIndex = 0;
      var closestDist = Infinity;
      items.forEach(function (item, i) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var dist = Math.abs(itemCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });
      return closestIndex;
    };

    var scrollTimer = null;
    var onScroll = function () {
      if (isSyncing) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        if (!isCarouselMode()) return;
        activeIndex = findClosestIndex();
        render();
        restartAutoplay();
      }, 120);
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (!isCarouselMode()) {
        items.forEach(function (item) { item.classList.remove('is-active'); });
        stopAutoplay();
      } else {
        render();
        startAutoplay();
      }
    });

    track.addEventListener('pointerdown', stopAutoplay, { passive: true });
    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', restartAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', restartAutoplay);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        restartAutoplay();
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { manualStep(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { manualStep(1); });
    }

    items.forEach(function (item, i) {
      var link = item.querySelector('a.shop-by-game__card');
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (isCarouselMode() && i !== activeIndex) {
          e.preventDefault();
          setActive(i);
          restartAutoplay();
        }
      });
    });

    if (isCarouselMode()) {
      track.scrollLeft = 0;
    }
    render();
    window.setTimeout(function () {
      activeIndex = findClosestIndex();
      render();
      startAutoplay();
    }, 250);
  }

  function init() {
    document.querySelectorAll('[data-shop-by-game]').forEach(initWheel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
